import React, { FC, InputHTMLAttributes, useState } from "react";
import { Link } from "react-router-dom";
import showPasswordIcon from "assets/icons/view-password.svg";
import hidePasswordIcon from "assets/icons/eye-slash.svg";

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  extraLink?: string;
  extraLinkPath?: string;
  placeholder?: string;
}

const TextField: FC<TextFieldProps> = ({
  label,
  extraLink,
  extraLinkPath,
  placeholder,
  type,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <div className="flex flex-col gap-1.5 w-full min-w-0">
      <div className="flex justify-between">
        {label && (
          <label className="text-base tracking-[0.16px] text-black">
            {label}
          </label>
        )}
        {extraLink && extraLinkPath && (
          <Link
            to={extraLinkPath}
            className="text-[#757575] text-sm leading-[19.5px]"
          >
            {extraLink}
          </Link>
        )}
      </div>

      <div className="flex gap-4 border border-[#AAAAAA] px-3 h-[50px] bg-[#F8FAFC] rounded-lg items-center overflow-hidden">
        <input
          type={isPasswordField ? (showPassword ? "text" : "password") : type}
          className="flex-1 h-full outline-none border-none bg-transparent placeholder:text-[#AAAAAA] truncate"
          placeholder={placeholder}
          {...props}
        />
        {isPasswordField && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="text-sm text-blue-500 hover:underline"
          >
            <img
              src={showPassword ? showPasswordIcon : hidePasswordIcon}
              alt=""
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default TextField;
